import { render } from "./Create.vue?vue&type=template&id=e810b206"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"
script.render = render

export default script